module.exports = __webpack_public_path__ + "assets/img/mh1.b027e01e.jpg";